import { render, staticRenderFns } from "./ModalAddLogo.vue?vue&type=template&id=19cab899&"
import script from "./ModalAddLogo.vue?vue&type=script&lang=js&"
export * from "./ModalAddLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports